module.exports = __webpack_public_path__ + "static/media/teafloor-portfolio-1.ca8dcb8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/teafloor-portfolio-1.jpg
// module id = 451
// module chunks = 0